<div
  class="file-uploader"
  *ngIf="platformControl.value === 'google' && authMethodControl.value === AuthenticationMethods.serviceAccount"
>
  <div class="file-uploader-key">
    {{ 'integrationPage.authDetails.serviceAccountPrivateKeyDetailsFieldKey' | labelsProvider }}
  </div>
  <div class="file-uploader-description">
    {{ 'integrationPage.authDescriptions.googleServiceAccountPrivateKeyDetails' | labelsProvider }}
  </div>
  <input
    id="#ServiceAccountJsonHiddenFileUploader"
    type="file"
    multiple
    (change)="onsServiceAccountJsonFileSelected($event)"
    hidden="true"
  />
  <div class="file-uploader-button" (click)="openFileSelectionDialog()">
    <img src="assets/images/common/import.svg" />
    <span>
      {{ 'common.uploadFile' | labelsProvider }}
    </span>
  </div>
  <div class="file-uploader-error" *ngIf="fileWarningMessage() !== ''">
    <span>
      {{ fileWarningMessage() }}
    </span>
  </div>
</div>

<div class="budibase-self-hosted-section" *ngIf="platformControl.value === 'budibase' && authMethodControl.value">
  <div class="detail-keyvalue">
    <app-detail-keyvalue
      [input]="credentialsDetails[0]"
      [placeholder]="
        !isInAddMode && !authMethodHadChanged && credentialsDetails[0] && credentialsDetails[0].isSensitive
          ? MOCK_SECRET_TEXT
          : ''
      "
    >
    </app-detail-keyvalue>
  </div>

  <div class="budibase-radio-section">
    <div class="title" [innerHTML]="'integrationPage.authDetails.selectSelfHostedFieldKey' | requiredFieldTitle"></div>
    <mat-radio-group
      [value]="selectedBudibaseSelfHostedOption"
      (change)="onBudibaseSelfHostedOptionChange($event.value)"
    >
      <mat-radio-button value="tenantId">
        {{ 'formErrors.tenantIdOptionLabel' | labelsProvider }}
      </mat-radio-button>
      <mat-radio-button value="customDomain">
        {{ 'formErrors.customDomainOptionLabel' | labelsProvider }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="detail-keyvalue" *ngIf="selectedBudibaseSelfHostedOption && credentialsDetails[1]">
    <app-detail-keyvalue
      [input]="credentialsDetails[1]"
      [placeholder]="
        !isInAddMode && !authMethodHadChanged && credentialsDetails[1] && credentialsDetails[1].isSensitive
          ? MOCK_SECRET_TEXT
          : ''
      "
    >
    </app-detail-keyvalue>
  </div>

  <div class="detail-keyvalue" *ngIf="selectedBudibaseSelfHostedOption === 'customDomain' && credentialsDetails[2]">
    <app-detail-keyvalue [input]="credentialsDetails[2]" [placeholder]="''"> </app-detail-keyvalue>
  </div>

  <div class="budibase-mtls-section" *ngIf="selectedBudibaseSelfHostedOption === 'customDomain'">
    <div class="mtls-toggle">
      <mat-slide-toggle [checked]="mtlsEnabled" (change)="onMtlsToggle($event.checked)">
        {{ 'integrationPage.authDetails.enableMtlsToggleLabel' | labelsProvider }}
      </mat-slide-toggle>
      <div class="mtls-description">
        {{ 'integrationPage.authDetails.enableMtlsToggleDescription' | labelsProvider }}
      </div>
    </div>
  </div>

  <ng-container *ngIf="mtlsEnabled">
    <div class="detail-keyvalue" *ngFor="let credential of credentialsDetails | slice: 3">
      <app-detail-keyvalue
        [input]="credential"
        [placeholder]="!isInAddMode && !authMethodHadChanged && credential.isSensitive ? MOCK_SECRET_TEXT : ''"
      >
      </app-detail-keyvalue>
    </div>
  </ng-container>
</div>

<div
  class="credentials-details-container"
  *ngIf="
    platformControl.value &&
    authMethodControl.value &&
    platformControl.value !== 'budibase' &&
    platformControl.value !== 'devices'
  "
>
  <div *ngFor="let credential of credentialsDetails" class="detail-keyvalue">
    <app-detail-keyvalue
      [input]="credential"
      [placeholder]="!isInAddMode && !authMethodHadChanged && credential.isSensitive ? MOCK_SECRET_TEXT : ''"
    >
    </app-detail-keyvalue>
  </div>
</div>

<div class="oauth-method" *ngIf="authMethodControl.value === AuthenticationMethods.oauthAuthorizationCode">
  <img
    src="{{ svgSignInPath }}"
    class="sign-in-button"
    (click)="signInUsingOauth()"
    [ngClass]="{
      'sign-in-button-disabled':
        (this.platformControl.value === 'service_now' &&
          (this.credentialsFormGroup.controls['service-now-instance-url'].valid === false ||
            this.credentialsFormGroup.controls['client-id'].valid === false)) ||
        userTryingToSignInUsingOauth ||
        userSignedInUsingOauth,
      'sign-in-button-required': formSubmitAttempt && !userSignedInUsingOauth && shouldUpdateCredentials,
    }"
  />
  <img *ngIf="userSignedInUsingOauth" class="successful-sign-in-v" src="assets/images/common/check.svg" />
</div>
